// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1764":"538244009b9872ff","4841":"b39dbd97004bc4b5","5233":"c796f0bc88917655","6178":"589437e8487c0aac","8142":"2157daceeb16d28b"}[chunkId] + ".css";
};